import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {ManufacturerOPEEnum} from "./ManufacturerOPEEnum";

class ManufacturerDTO {
  id!: number;
  name!: string;
}

class O {
  manufacturers!: ManufacturerDTO[];
}

/**
 * O Inner Class
 */
class I {

}

export class GetManufacturersCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(ManufacturerOPEEnum.GetManufacturers);
    this.i = new I();
    this.o = new O();
  }
}
